import { render } from "./QuestionChoice.vue?vue&type=template&id=735d3a0a"
import script from "./QuestionChoice.vue?vue&type=script&lang=js"
export * from "./QuestionChoice.vue?vue&type=script&lang=js"

import "./QuestionChoice.vue?vue&type=style&index=0&id=735d3a0a&lang=scss"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__